import './ui/styles.css';
import 'primeicons/primeicons.css';
import 'vue-toastification/dist/index.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { quillEditor } from 'vue3-quill';
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar';
import ToastPlugin from 'vue-toastification';
import {
  UiAccordion,
  UiAccordionTab,
  UiBadge,
  UiButton,
  UiCalendar,
  UiCard,
  UiChart,
  UiCheckbox,
  UiColumn,
  UiConfirmDialog,
  UiConfirmPopup,
  UiDataTable,
  UiDataView,
  UiDialog,
  UiDropdown,
  UiGalleria,
  UiInputMask,
  UiInputNumber,
  UiInputText,
  UiMenubar,
  UiMessage,
  UiMultiSelect,
  UiPanel,
  UiPassword,
  UiProgressBar,
  UiProgressSpinner,
  UiRadioButton,
  UiSlider,
  UiTabMenu,
  UiTabPanel,
  UiTabView,
  UiTextarea,
} from './ui/components';

const app = createApp(App).use(store).use(router);

console.log("ENV = " + process.env.NODE_ENV);

app.component('Dialog', UiDialog);
app.component('Textarea', UiTextarea);
app.component('Button', UiButton);
app.component('Card', UiCard);
app.component('InputText', UiInputText);
app.component('RadioButton', UiRadioButton);
app.component('Checkbox', UiCheckbox);
app.component('Calendar', UiCalendar);
app.component('DataTable', UiDataTable);
app.component('Column', UiColumn);
app.component('Panel', UiPanel);
app.component('Chart', UiChart);
app.component('TabView', UiTabView);
app.component('TabPanel', UiTabPanel);
app.component('Dropdown', UiDropdown);
app.component('Menubar', UiMenubar);
app.component('Message', UiMessage);
app.component('InputNumber', UiInputNumber);
app.component('Password', UiPassword);
app.component('ConfirmPopup', UiConfirmPopup);
app.component('ConfirmDialog', UiConfirmDialog);
app.component('ProcessSpinner', UiProgressSpinner);
app.component('ProgressSpinner', UiProgressSpinner);
app.component('ProgressBar', UiProgressBar);
app.component('InputMask', UiInputMask);
app.component('Accordion', UiAccordion);
app.component('AccordionTab', UiAccordionTab);
app.component('MultiSelect', UiMultiSelect);
app.component('Slider', UiSlider);
app.component('DataView', UiDataView);
app.component('Badge', UiBadge);
app.component('Galleria', UiGalleria);
app.component('TabMenu', UiTabMenu);
app.component('CalendarView', CalendarView);
app.component('CalendarViewHeader', CalendarViewHeader);

app.use(quillEditor);
app.use(ToastPlugin, {
  position: 'top-right',
  timeout: 2500,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
});
app.mount('#app');
